<template>
  <el-dialog
    custom-class="base-dialog"
    :class="[`base-dialog-${dialogSize}`]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
    <slot
      slot="footer"
      name="footer"
    />
  </el-dialog>
</template>

<script>
export default {
  name: 'BaseDialog',
  props: {
    // 决定弹窗的大小(默认为大弹窗)
    dialogSize: {
      type: String,
      default: 'big',
    },
  },
}
</script>

<style lang="less" scoped>
// 默认为大号弹窗
/deep/ .base-dialog {
  height: 640px;
  width: 960px;
  .el-dialog__header {
    background: #021528;
    padding: 8px 20px;
    line-height: 0;
    .el-dialog__title {
      color: #fff;
    }
    .el-dialog__headerbtn {
      top: 16px;
      i {
        color: #fff;
      }
    }
  }
  .el-dialog__body {
    height: 480px;
    overflow: hidden;
  }
  // 服务于基础数据以及用户管理的列表样式start
  /deep/ .dialog-content {
    display: flex;
    width: 920px;
    flex-wrap: wrap;
    .dialog-content-item {
      width: 380px;
      margin-left: 70px;
      height: 36px;
      margin-top: 30px;
      .el-input {
        width: 240px;
      }
      .item-text {
        display: inline-block;
        min-width: 85px;
        text-align: right;
        &::before {
          content: '*';
          color: #c7004c;
        }
      }
      .item-text.no-important::before {
        content: '';
      }
      &:nth-child(1),
      &:nth-child(2) {
        margin-top: 0;
      }
    }
  }
  // 服务于基础数据以及用户管理的列表样式end
}

//  正常弹窗
.base-dialog-normal {
  /deep/.base-dialog {
    width: 830px;
    height: 450px;
    .el-dialog__body {
      height: auto;
      padding: 20px 40px 10px !important;
    }
  }
}
//  中号弹窗
.base-dialog-medium {
  /deep/.base-dialog {
    height: 480px;
    width: 640px;
    .el-dialog__body {
      height: auto;
      padding: 20px 20px 10px 20px !important;
    }
  }
}

// 小号弹窗
.base-dialog-small {
  /deep/.base-dialog {
    height: 370px;
    width: 575px;
    .el-dialog__body {
      height: auto;
      // padding: 20px 20px 10px 20px !important;
    }
  }
}
</style>
